export default __webpack_public_path__ + "static/media/1440.1da32708.png";